/**
 * @generated SignedSource<<6e312dcc8b96bdaa84c82a5ecd1f2a7e>>
 * @relayHash 6feda2c636321e3c88a77e699a034c9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8ad012f992c913ec0526618f2ba46d2fa4bcb43d20abdc839f331e3e3a4846a8

import type { ConcreteRequest } from 'relay-runtime';
export type useOnSubmitQuery$variables = {
  cloudId: string;
};
export type useOnSubmitQuery$data = {
  readonly jira: {
    readonly isGlobalAdmin: boolean | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly offering: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type useOnSubmitQuery = {
  response: useOnSubmitQuery$data;
  variables: useOnSubmitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "alias": "isGlobalAdmin",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Literal",
          "name": "key",
          "value": "ADMINISTER"
        }
      ],
      "kind": "ScalarField",
      "name": "hasGlobalPermission"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useOnSubmitQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
          }
        ]
      },
      (v4/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnSubmitQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
          }
        ]
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "id": "8ad012f992c913ec0526618f2ba46d2fa4bcb43d20abdc839f331e3e3a4846a8",
    "metadata": {},
    "name": "useOnSubmitQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d14c72be0d76cac081af4321fa5a4b8e";

export default node;
